// import store from '../store/index'
//------------------
// set skill values
//------------------
export default function setSkillValues() {
  console.log('----------------------------')
  console.log('IN setSkillValues')
  // -----------------
  // define structure
  // -----------------
  let skill = {
    //
    originalIndex: 0,
    name: '',
    cur: 0,
    cur_no_adjs: 0,
    incr_percent: 0,
    formula: '',
    formula_arg1: '',
    formula_arg2: '',
    formula_arg3: '',
    formula_oper1: '',
    formula_oper2: '',
    description: '',
    base: 0,
    ticks: 0,
    training: 0,
    adjs_tot: 0,
    parent_name: '',
    parent_cur: 0,
    action_delete: false,
    ticks_max: 0,
    category: 'Core',
    type: '',
    group: '',
    default: false,
    tickable: false,
    dex_based: false,
    capped_ticks: false,
    capped_skill: false,
    id: 0,
  }
  return skill
}
